import { Modal, Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import UserAvatar from './UserAvatar';
import LocationSelector from './LocationSelector';

function PermissionsModal({
  show, onClose, onSave, saving,
  selectedUser, setSelectedUser,
  locationData, loadingLocations,
  selectedProvinces, setSelectedProvinces,
  selectedDistricts, setSelectedDistricts,
  selectedDivisions, setSelectedDivisions,
}) {
  if (!selectedUser) return null;

  const isApproval = selectedUser.status === 'pending';

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton className="um-modal-header">
        <Modal.Title>
          <i className={`bi ${isApproval ? 'bi-person-check' : 'bi-shield-lock'} me-2`}></i>
          {isApproval ? 'Approve User' : 'Edit Permissions'}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* User banner */}
          <div className="um-user-banner mb-4">
            <UserAvatar user={selectedUser} large />
            <div>
              <div className="fw-semibold">{selectedUser.name || '—'}</div>
              <div className="small text-muted">{selectedUser.email}</div>
            </div>
          </div>

          {/* Access type + level */}
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label className="um-field-label">Access Type</Form.Label>
                <Form.Select
                  value={selectedUser.access_type}
                  onChange={e => setSelectedUser({ ...selectedUser, access_type: e.target.value })}
                >
                  <option value="viewer">Viewer — read only</option>
                  <option value="editor">Editor — register &amp; edit</option>
                  {selectedUser.access_level !== 'dsd' && (
                    <option value="admin">Admin — full access</option>
                  )}
                </Form.Select>
                {selectedUser.access_level === 'dsd' && (
                  <Form.Text className="text-muted">Admin role is not available at DS Division level.</Form.Text>
                )}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label className="um-field-label">Access Level</Form.Label>
                <Form.Select
                  value={selectedUser.access_level}
                  onChange={e => {
                    const newLevel = e.target.value;
                    setSelectedUser({
                      ...selectedUser,
                      access_level: newLevel,
                      access_type: newLevel === 'dsd' && selectedUser.access_type === 'admin' ? 'editor' : selectedUser.access_type,
                    });
                    setSelectedProvinces([]);
                    setSelectedDistricts([]);
                    setSelectedDivisions([]);
                  }}
                >
                  <option value="all-island">All Island</option>
                  <option value="province">Province</option>
                  <option value="district">District</option>
                  <option value="dsd">DS Division</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {/* Location selector */}
          <LocationSelector
            accessLevel={selectedUser.access_level}
            locationData={locationData}
            loadingLocations={loadingLocations}
            selectedProvinces={selectedProvinces}
            setSelectedProvinces={setSelectedProvinces}
            selectedDistricts={selectedDistricts}
            setSelectedDistricts={setSelectedDistricts}
            selectedDivisions={selectedDivisions}
            setSelectedDivisions={setSelectedDivisions}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer className="border-top-0 pt-0">
        <Button variant="outline-secondary" onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          style={{ background: 'linear-gradient(135deg, #667eea, #764ba2)', border: 'none' }}
          onClick={onSave}
          disabled={saving}
        >
          {saving ? (
            <><Spinner animation="border" size="sm" className="me-2" />Saving…</>
          ) : (
            <><i className="bi bi-floppy me-1"></i>Save &amp; Activate</>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PermissionsModal;
